import { render } from "./View622.vue?vue&type=template&id=56eb709a"
import script from "./View622.vue?vue&type=script&lang=js"
export * from "./View622.vue?vue&type=script&lang=js"

import "./View622.vue?vue&type=style&index=0&id=56eb709a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__